import { useMemo } from 'react';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { getTakenCourses } from '../selectors';
import {
  getCompletedNumberOfResources,
  getCourseReflectionSeries,
  getCourseSeries,
  getCourseTotalNumberOfResources,
} from '../utils';

const useCourseDashboard = course => {
  const takenCourses = useSelector(getTakenCourses);

  const seriesProgress = course
    ? _get(takenCourses[course.sys.id], 'seriesProgress', {})
    : {};

  const completedSeriesIds = course
    ? _get(takenCourses[course.sys.id], 'completedSeriesIds', [])
    : [];

  const completedModulesIds = course
    ? _get(takenCourses[course.sys.id], 'completedModulesIds', [])
    : [];

  const courseModules = _get(course, ['fields', 'modules'], []);
  const totalNumberOfModules = courseModules.length;

  const courseSeries = useMemo(() => getCourseSeries(course), [course]);

  const totalNumberOfResources = useMemo(
    () => getCourseTotalNumberOfResources(courseSeries),
    [courseSeries],
  );

  const completedNumberOfResources = useMemo(
    () => getCompletedNumberOfResources(courseSeries, seriesProgress),
    [seriesProgress, courseSeries],
  );

  const completedNumberOfModules = courseModules.filter(m =>
    completedModulesIds.includes(m.sys.id),
  ).length;

  const isCourseCompleted = totalNumberOfModules === completedNumberOfModules;

  const courseProgress = Math.round(
    (completedNumberOfResources / (totalNumberOfResources || 1)) * 100,
  );

  const reflectionSeries = useMemo(
    () => getCourseReflectionSeries(courseSeries),
    [courseSeries],
  );

  const completedNumberOfReflections = reflectionSeries.reduce(
    (acc, series) =>
      completedSeriesIds.includes(series.sys.id) ? acc + 1 : acc,
    0,
  );

  return {
    courseSeries,
    reflectionSeries,
    courseProgress,
    completedNumberOfReflections,
    completedNumberOfModules,
    totalNumberOfModules,
    totalNumberOfResources,
    isCourseCompleted,
  };
};

export default useCourseDashboard;
